/**
 * Nerivio n-level-menu JS
 */

/* eslint-disable */
(function nLevelMenuComp($, Drupal) {
  Drupal.behaviors.myModule = {
    attach: function(context, settings) {

      function menuJS(context) {
        let hoverTimeout;

        $('.n-level .li-menu.haschild', context).off('mouseenter mouseleave');
        $('.n-level .li-menu.haschild > a', context).off('click');

        const isDesktop = window.matchMedia("(min-width: 1290px)").matches;

        if (isDesktop) {
          $('.n-level .li-menu.haschild', context)
            .on('mouseenter', function () {
              clearTimeout(hoverTimeout);

              const $this = $(this);
              const $menuWrapper = $this.closest('.n-level');

              $menuWrapper.find('.li-menu.haschild.expand')
                .not($this)
                .removeClass('expand');

              $this.addClass("expand");
            })
            .on('mouseleave', function () {
              const $this = $(this);
              hoverTimeout = setTimeout(function () {
                $this.removeClass("expand");
              }, 200);
            })
            .each(function () {
              const $firstLink = $(this).find('a').first();
              $firstLink.on('click', function (e) {
                e.preventDefault();
              });
            });
        } else {
          $('.n-level .li-menu.haschild > a', context)
            .on('click', function(e) {
              e.preventDefault();
              e.stopPropagation();

              const $parentLi = $(this).closest('.li-menu.haschild');
              const $menuWrapper = $parentLi.closest('.n-level');

              $menuWrapper.find('.li-menu.haschild.expand')
                .not($parentLi)
                .removeClass('expand')
                .children('.n-level-child-wrapper')
                .slideUp();

              if ($parentLi.hasClass('expand')) {
                $parentLi.removeClass('expand');
                $parentLi.children('.n-level-child-wrapper').slideUp();
              } else {
                $parentLi.addClass('expand');
                $parentLi.children('.n-level-child-wrapper').slideDown();
              }
            });
        }
      }

      menuJS(context);

      let resizeTimeout;
      $(window).on('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          menuJS(context);
        }, 100);
      });
    }
  };
})(jQuery, Drupal);
